import script from "./AppLeftMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./AppLeftMenu.vue?vue&type=script&setup=true&lang=js"

import "./AppLeftMenu.vue?vue&type=style&index=0&id=6f9278ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f9278ea"]])

export default __exports__